import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["modal"];

  connect() {
    $(".close-reveal-modal, .reveal-modal-bg").on("click", (e) => {
      if(($(e.target).hasClass("reveal-modal-bg") || $(e.target).hasClass("close-reveal-modal")) && (this.modalTarget.dataset.updatedProperties === 'true' || window.modal.dirty)) {
        e.preventDefault();
        e.stopPropagation();
        this.showModal(this.modalTarget);
      }
    })

    this.removeController();
  }

  showModal(modalTarget) {
    let message = '';

    const { updatedProperties, sitesEmpty } = this.modalTarget.dataset;

    if (updatedProperties === 'true') {
      if (sitesEmpty === 'true') {
        message = "<p>Integration of Google Analytics is not yet complete. Are you sure you want to leave?</p>";
        this.closeModal(modalTarget, message);
      } else {
        message = "<p>We’ve detected changes to your Google Properties.</p> <p>If you exit without saving, the affected properties will be disconnected.</p>";
        this.saveAndCloseModal(modalTarget, message);
      }
    } else {
      message = "<p>You have unsaved changes. Are you sure you want to leave?</p>";
      this.closeModal(modalTarget, message);
    }
  }

  closeModal(modalTarget, message) {
    let dialog = this.createDialog(message);

    dialog.dialog({
      dialogClass: "ga-unsaved-properties-modal",
      resizable: false,
      draggable: false,
      modal: true,
      title: "Unsaved Changes",
      buttons: {
        ["No"]: function () {
          $(this).dialog("destroy");
        },
        ["Yes"]: function () {
          $(this).dialog("destroy");
          modalTarget.removeAttribute("data-controller");
          window.modal.dirty = false;
          window.modal.close();
        },
      },
    });
  }

  saveAndCloseModal(modalTarget, message) {
    let dialog = this.createDialog(message);

    dialog.dialog({
      dialogClass: "ga-fetched-unsaved-properties-modal",
      resizable: false,
      draggable: false,
      modal: true,
      title: "Unsaved Changes",
      buttons: {
        ["Exit without saving"]: function () {
          $(this).dialog("destroy");
          modalTarget.removeAttribute("data-controller");
          window.modal.dirty = false;
          window.modal.close();
        },
        ["Save & Exit"]: function () {
          $(this).dialog("destroy");
          modalTarget.removeAttribute("data-controller");
          window.modal.dirty = false;
          $('.ga-save-btn').click();
        },
      },
    });
  }

  createDialog(message) {
    let dialog = $(
      `<div id="dialog-confirm" role="alert">${message}</div>`
    );

    if (!$("#dialog-confirm").length) $("body").append(dialog);

    $(".reveal-modal-bg").css("z-index", 1000);

    return dialog;
  }

  removeController() {
    $(".ga-save-btn, .refresh-ga-properties").on("click", () => {
      this.modalTarget.removeAttribute("data-controller");
    })
  }

  disconnect() {
    $(".ga-save-btn, .close-reveal-modal, .reveal-modal-bg").off("click");
  }
}
